/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} PriceInputs */

const en_price = /** @type {(inputs: PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price`)
};

const es_price = /** @type {(inputs: PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precio`)
};

const fr_price = /** @type {(inputs: PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prix`)
};

const de_price = /** @type {(inputs: PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preis`)
};

const ja_price = /** @type {(inputs: PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`価格`)
};

const zh_price = /** @type {(inputs: PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`价格`)
};

const ar_price = /** @type {(inputs: PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`السعر`)
};

const id_price = /** @type {(inputs: PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harga`)
};

const it_price = /** @type {(inputs: PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prezzo`)
};

const ru_price = /** @type {(inputs: PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цена`)
};

const pt_price = /** @type {(inputs: PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preço`)
};

const ko_price = /** @type {(inputs: PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`가격`)
};

/**
* | output |
* | --- |
* | "Price" |
*
* @param {PriceInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const price = /** @type {((inputs?: PriceInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<PriceInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_price(inputs)
	if (locale === "es") return es_price(inputs)
	if (locale === "fr") return fr_price(inputs)
	if (locale === "de") return de_price(inputs)
	if (locale === "ja") return ja_price(inputs)
	if (locale === "zh") return zh_price(inputs)
	if (locale === "ar") return ar_price(inputs)
	if (locale === "id") return id_price(inputs)
	if (locale === "it") return it_price(inputs)
	if (locale === "ru") return ru_price(inputs)
	if (locale === "pt") return pt_price(inputs)
	return ko_price(inputs)
});